import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Tiles from "../../components/tiles"

import Carousel from "../../components/carousel"
import TextBlock from "../../components/textBlock"
import Numbers from "../../components/numbers"
import Section from "../../components/section"
import Card from "../../components/card"

import CapitaSVG from "../../images/clients/Capita logo.svg"
import PrettyLittleThingImage from "../../images/plt-logo.png"

import Capita from "../../images/clients/capita.png"
import PrettyLittleThing from "../../images/clients/prettylittlething.png"

import HeroSVG from "../../images/solutions/contact_centre/contact_centre.svg"

import TransformationSVG from "../../images/transformation.svg"
import ChatbotSVG from "../../images/chatbot.svg"
import CloudTechSVG from "../../images/Cloud_Tech.svg"
import IntegrationSVG from "../../images/solutions/contact_centre/integration.svg"
import DesktopSVG from "../../images/solutions/contact_centre/desktop.svg"
import PaymentsSVG from "../../images/solutions/contact_centre/payments.svg"
import AISVG from "../../images/solutions/contact_centre/ai_automation.svg"
import ManagedServiceSVG2 from "../../images/solutions/contact_centre/managedservice.svg"

import FirstLogo from "../../images/work/first_logo.svg"
import FirstBg from "../../images/work/first_bg.jpg"

import Connect from "../../images/solutions/contact_centre/connect.svg"
import AWS from "../../images/home/consulting-partner.png"

const carouselData = [
  {
    title: "Bring the future of Digital Contact Centres.",
    subtitle: "Redefining world-class customer experience",
    image: HeroSVG,
  },
]

const tilesData = [
  {
    backgroundImage: FirstBg,
    foregroundImage: FirstLogo,
    link: "/clients/firstgroup",
  },
  {
    backgroundImage: Capita,
    foregroundImage: CapitaSVG,
  },
  {
    backgroundImage: PrettyLittleThing,
    foregroundImage: PrettyLittleThingImage,
    link: "/clients/prettylittlething",
  },
]

const ContactCentre = () => (
  <Layout>
    <SEO
      title="Redefining World Class Customer Experience With Modern Contact Centre Techologies"
      description="Take giant leaps in contact management and customer experience with modern, scalable communications technology that transforms customer experience "
      keywords="digital customer experience, contact centre, amazon connect, amazon lex, amazon polly, customer journey, omnichannel cloud, uk technology companies, cloud communications, cloud phone provider, manchester tech, tech startup, mobile technology, app development, software companies, tech startup manchester, tech company lancashire, manchester digital, circleloop, smartagent, aws partner "
      robots="index, follow"
      revisit_after="1 month"
    />
    <Carousel data={carouselData} />
    <TextBlock
      contrast
      title="<span>Giant leaps in</span> contact management and customer experience."
    >
      <p>
        Customer service has changed. Your customers demand more and traditional
        contact centre technology no longer makes the cut. Our platform
        redefines what world-class customer experience means, whilst maximising
        efficiency and reducing cost.
      </p>
    </TextBlock>
    <section className="centre"></section>
    <Section title={"CX Transformation."} image={TransformationSVG} padded>
      We’ll help you bring your future contact centre to life with our proven
      solution design, implementation and migration approach. Our experts will
      help enable the right processes and technologies to achieve world-class
      experience, along with migration, training and support services.
    </Section>
    <Section title={"Cloud Technology."} image={CloudTechSVG} reverse padded>
      We build, provide and support next-generation cloud technologies that
      breaks down the barriers to world-class customer experience. Our expertise
      spans the market-leading contact centre technology from omnichannel
      platforms, to advisor software, high performance productivity tools and
      system integration.
    </Section>
    <Section title={"Chatbots & Automation."} image={ChatbotSVG} padded>
      We specialise in the design and development of AI-driven chatbots and
      automation that blends seamlessly into your customer journeys. Whether
      it’s voice, chat, SMS, social media or WhatsApp we enable extraordinary
      efficiency gains, customer service improvement and better advisor
      engagement.
    </Section>
    <section>
      <div className="contrast">
        <div className="centre">
          <div className="aws">
            <div className="aws__heading">
              <h2>
                <span>Our Technology & Solutions.</span>
              </h2>
              <hr />
            </div>
            <img src={AWS} alt="" className="section-partner" />
          </div>
          <br />
        </div>
      </div>
      <div className="contrast">
        <div className="centre">
          <div className="col3 cards">
            <Card
              image={Connect}
              title={"Amazon Connect"}
              subtitle={"Consultancy, implementation & support services."}
              link={"/solutions/amazon-connect"}
            />
            <Card
              image={IntegrationSVG}
              title={"Integration"}
              subtitle={"Ready-made connections & bespoke integration."}
              link={"/integrations"}
            />
            <Card
              image={DesktopSVG}
              title={"Agent Desktop"}
              subtitle={"Suite of contact centre & agent efficiency software."}
              link={"/products/smartagent"}
            />
            <Card
              image={PaymentsSVG}
              title={"Payments & PCI"}
              subtitle={"Automated PCI-compliant payment handling."}
              link={"/solutions/payments-pci"}
            />
            <Card
              image={AISVG}
              title={"AI & ML Automation"}
              subtitle={"Smart chatbots & process automation."}
              link={"/solutions/contact-automation"}
            />
            <Card
              image={ManagedServiceSVG2}
              title={"Managed Service"}
              subtitle={"Consultancy, implementation & support services."}
              link={"/solutions/contact-centre"}
            />
          </div>
        </div>
      </div>
    </section>
    <TextBlock title="Powering competitive advantages." />
    <Tiles data={tilesData} />
    <Numbers
      data={[
        { value: "215 sec", label: "Reduction in average handle time." },
        { value: "25%", label: "Reduction in contact volume." },
        {
          value: "150",
          label:
            "Agent hours saved per week.                                                                                                                                      ",
        },
      ]}
    />
    {/* <div className="inverse section-padding">
      <TextBlock title="End-to-end team collaboration.">
        <section className="lists inverse">
          <List
            color={"red"}
            img={CallingSVG}
            title={"Calling"}
            points={[
              "Scalable voice network",
              "100% cloud based",
              "Built for mobility",
              "No on-premise hardware",
              "Instant user & number provisioning",
              "Powerful MI suite",
            ]}
          />
          <List
            color={"blue"}
            img={CollabSVG}
            title={"Collaboration"}
            points={[
              "Internal Calling",
              "Call transfer",
              "Internal messaging",
              "Audio conferencing",
              "Video conferencing",
            ]}
          />
          <List
            color={"green"}
            img={ManagedServiceSVG}
            title={"Managed Service"}
            points={[
              "Dedicated support",
              "P1 24/7 available",
              "Proactive monitoring",
              "Hardware provision",
              "Evergreen development",
            ]}
          />
        </section>
      </TextBlock>
    </div> */}
  </Layout>
)

export default ContactCentre
